/**
 * Hotglue configuration
 *
 * This file centralizes the Hotglue configuration settings.
 * The configuration values are loaded from environment variables.
 */

/**
 * Returns the Hotglue configuration object with API key and environment ID
 *
 * @returns {Object} Hotglue configuration object
 */
const getHotglueConfig = () => {
  return {
    apiKey: process.env.REACT_APP_HOTGLUE_API_KEY || '',
    envId: process.env.REACT_APP_HOTGLUE_ENV_ID || '',
  };
};

/**
 * Returns the Hotglue flow ID from environment variables
 *
 * @returns {string} Hotglue flow ID
 */
export const getHotglueFlowId = () => {
  return process.env.REACT_APP_HOTGLUE_FLOW_ID || '';
};

export default getHotglueConfig;
